import {Icon, Text} from '@smart/web-components';
import type {Maybe} from 'graphql/jsutils/Maybe';
import React, {useState} from 'react';
import {useEffect} from 'react';
import styles from './index.module.scss';

type SubHeaderAreaTypes = {
  uniqueSellingPoints?: string | readonly Maybe<string>[];
};

const SubheaderArea = ({
  uniqueSellingPoints,
}: SubHeaderAreaTypes): JSX.Element => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const baseClass = `headerArea`;

  // Increment currentIndex every 2000ms
  useEffect(() => {
    if (!uniqueSellingPoints) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex: number) =>
        prevIndex === uniqueSellingPoints.length - 1
          ? 0
          : (prevIndex + 1) % uniqueSellingPoints.length,
      );
    }, 2000);
    return () => clearInterval(interval);
  }, [uniqueSellingPoints]);

  const getTrimmedText = (text: string, maxLength: number) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + `...`
      : text;
  };

  return (
    <ul className={styles[`${baseClass}__subheading`]}>
      {Array.isArray(uniqueSellingPoints) &&
        uniqueSellingPoints.map((text: string, index: number) => {
          const trimmedText = getTrimmedText(text, 40);
          const isActive = index === currentIndex;
          const listItem = `__listItem`;
          return (
            <li
              key={`${text}_${index}`}
              className={`${styles[`${baseClass}${listItem}`]} ${
                isActive
                  ? styles[`${baseClass}${listItem}-active`]
                  : styles[`${baseClass}${listItem}-inactive`]
              }`}
            >
              <Icon name="successful-checkmark--small" />
              <Text
                className={styles[`${baseClass}__mobileUSP`]}
                variant="paragraph-100"
              >
                {text}
              </Text>
              <Text
                className={styles[`${baseClass}__desktopUSP`]}
                variant="paragraph-100"
              >
                {trimmedText}
              </Text>
            </li>
          );
        })}
    </ul>
  );
};

export default SubheaderArea;
